import React, { Component } from 'react'
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl'
import Toggle from "react-toggle";
import PaymentTypeSelect from "../../payment-type/paymenttypeselect.jsx"

const messages = defineMessages({
    "note_placeholder": {
        id: 'invoice.receive_payment.note_placeholder',
        defaultMessage: 'Payment notes',
    },
})

class BulkApplyInvoicesPaymentsForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            paymentType: 'credit-card',
            notes: '',
            useCardsOnFile: false,
            onClose: this.props.onClose || function () { },
            onChange: this.props.onChange || function () { },
            customPaymentTypeId: '',
        }
        this.onChange = this.onChange.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
    }

    componentDidMount() {
        this.onChange()
    }

    handleFormChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        }, this.onChange)
    }

    onChange() {
        this.state.onChange({
            paymentType: this.state.paymentType,
            notes: this.state.notes,
            useCardsOnFile: this.state.useCardsOnFile,
            paymentTypeId: this.state.customPaymentTypeId,
        })
    }

    render() {
        return <div>
            <div className={'row d-flex justify-content-center'}>
                <div className={'col-8 pb-4 text-center'}>
                    <em>
                        <FormattedMessage
                            id="bulk.operations.apply_invoices_payments.description"
                            defaultMessage="Invoices will be paid fully (based on the balance) with the payment type chosen"
                        />
                    </em>
                </div>
            </div>
            <div className="form-group row mb-1">
                <label className="col-12 col-md-3  col-form-label custom-form-label pb-2" htmlFor="paymentType">
                    <FormattedMessage
                        id="invoice.receive_payment.payment_type_label"
                        defaultMessage="Payment type"
                    />
                </label>
                <div className="col-12 col-md-9 mb-3">
                    <PaymentTypeSelect 
                    paymentType={this.state.customPaymentTypeId?this.state.customPaymentTypeId:this.state.paymentType} 
                    onChange={(paymentType, customPaymentTypeId) => {
                        this.setState({
                            paymentType,
                            customPaymentTypeId,
                        }, this.onChange)
                    }} />
                </div>
            </div>
            <div className="form-group row mb-3">
                <label className="col-12 col-md-3  col-form-label custom-form-label pb-2" htmlFor={'notes'}>
                    <FormattedMessage
                        id="invoice.receive_payment.note_label"
                        defaultMessage="Note"
                    />
                </label>
                <div className="col-12 col-md-9">
                    <textarea
                        name="notes"
                        value={this.state.notes}
                        onChange={this.handleFormChange}
                        id="notes"
                        rows="3"
                        className="form-control"
                        placeholder={this.props.intl.formatMessage(messages["note_placeholder"])}
                    />
                </div>
            </div>
            {this.state.paymentType === 'credit-card' ? <div className="form-group row">
                <label className="col-12 col-md-3  col-form-label custom-form-label pb-2" htmlFor={'useCardsOnFile'}>
                    <FormattedMessage
                        id="bulk.operations.apply_invoices_payments.use_cards_on_file"
                        defaultMessage="Use cards on file"
                    />
                </label>
                <div className="col-9">
                    <div className="input-group">
                        <Toggle
                            id={'useCardsOnFile'}
                            defaultChecked={this.state.useCardsOnFile}
                            checked={this.state.useCardsOnFile}
                            icons={false}
                            onChange={() => {
                                this.setState({
                                    useCardsOnFile: !this.state.useCardsOnFile
                                }, this.onChange)
                            }} />

                    </div>
                    <div className={'w-100'}>
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="bulk.operations.apply_invoices_payments.use_cards_on_file_description"
                                defaultMessage="If the contact has a card on file, it will be charged. If not, it will skip the invoice"
                            />
                        </small>
                    </div>
                </div>
            </div> : ''}
        </div>
    }
}

export default injectIntl(BulkApplyInvoicesPaymentsForm)





// WEBPACK FOOTER //
// ./src/bulk/operations/apply-invoices-payments.component.jsx